import React from 'react';
import { TEXTBLOCK_IMAGE_MAX_COUNT } from '../../shared/constants/limits';
import { getPageMessage } from '../../shared/constants/pageMessages';
import ImageDropLayer from '../../shared/component/ImageDropLayer';

interface TextImageDropLayerProps {
  isVisible: boolean;
  remainingCount: number;
}

const TextImageDropLayer: React.FC<TextImageDropLayerProps> = ({
  isVisible,
  remainingCount,
}) => {
  return (
    <ImageDropLayer
      isVisible={isVisible}
      title={getPageMessage('DRAG_DROP_CREATE_TEXT_IMAGE')}
      description={getPageMessage('DRAG_DROP_TEXT_IMAGE_LIMIT', {
        remainingCount,
        maxCount: TEXTBLOCK_IMAGE_MAX_COUNT,
      })}
    />
  );
};

export default TextImageDropLayer;
